<template>
    <div class="search-container">
        <div class="search-component" v-if="showSearchBar">
            <search-component
                class="search-box"
                placeholder="Search all fields"
                v-if="$root.isDesktop"
                :search-filter="searchText"
                :handle-search-on-type="true"
                @onSearch="handleFilterOrSearch"
            />
        </div>

        <div class="filter-container" v-if="showGridFilter">
            <grid-filter-manager
                v-if="gridApi"
                :grid-api="gridApi"
                :get-search-text="() => searchText"
                :set-search-text="
                    (v) => {
                        searchText = v;
                        refreshServerSide();
                    }
                "
                :grid-url="gridUrl"
                @default-filter-loaded="filterHasLoaded"
            />
        </div>
    </div>
</template>
<script>
import GridFilterManager from '@/AgGridComponents/grid-filter-manager';
import { SearchComponent } from '@/components';

export default {
    name: 'SearchFilterManager',
    components: { GridFilterManager, SearchComponent },
    props: {
        gridApi: {
            type: Object,
            required: true
        },
        gridUrl: {
            type: String,
            required: true
        },
        refreshServerSide: {
            type: Function,
            required: true
        },
        showSearchBar: {
            type: Boolean,
            default: true
        },
        showGridFilter: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            searchText: ''
        };
    },
    methods: {
        // eslint-disable-next-line func-names
        handleFilterOrSearch: _.debounce(function(val) {
            this.searchText = val.searchText;
            this.$emit('onSearch',  this.searchText);
        }, 1000),
        filterHasLoaded() {
            this.$emit('filter-loaded');
        }
    }
};
</script>

<style lang="scss" scoped>
.search-container {
    display: flex;
    .search-component {
        width: 270px;
        .search-box {
            justify-content: flex-start;
        }
    }
    padding: 12px 0;

    .filter-container {
        margin-left: auto;
    }
}
</style>
